// extracted by mini-css-extract-plugin
export default {"container":"GroupFileInformation_container__8R+09","dataTableContainer":"GroupFileInformation_dataTableContainer__11lt6","inactive":"GroupFileInformation_inactive__ukOF6"};